<template>
    <div>
        <div class="px-2">
            <table>
                <tr>
                    <td class="caption grey--text">Day</td>
                    <td class="caption grey--text pl-2">Working Hours</td>
                    <td class="caption grey--text" style="white-space: nowrap">Target Hours</td>
                </tr>
                <tr>
                    <td colspan="3"><v-divider></v-divider></td>
                </tr>
                <tr v-for="n in 7">
                    <td class="subtitle-1">{{dayTitles[n-1]}}</td>
                    <td style="width: 100%">
                        <app-working-hours-slider
                                :value="workingHours[n-1]"
                                @input="sliderInput(workingHours[n-1], $event)"
                                :title="dayTitles[n-1]"
                        /></td>
                    <td>
                        <div class="d-flex align-center">
                            <v-btn
                                    x-small
                                    color="primary"
                                    icon
                                    @click="workingHours[n-1].target = workingHours[n-1].target < 24 ? workingHours[n-1].target + 0.5 : workingHours[n-1].target"
                            >
                                <v-icon>mdi-chevron-up-circle-outline</v-icon>
                            </v-btn>

                            <div class="text--primary subtitle-1 flex-grow-1 text-center">
                                {{workingHours[n-1].target}}
                            </div>

                            <v-btn
                                    x-small
                                    color="primary"
                                    icon
                                    @click="workingHours[n-1].target = workingHours[n-1].target > 0 ? workingHours[n-1].target - 0.5 : workingHours[n-1].target"
                            >
                                <v-icon>mdi-chevron-down-circle-outline</v-icon>
                            </v-btn>
                        </div>
                    </td>
                </tr>
            </table>
        </div>
        <div class="d-flex justify-end pb-4 pr-2">
            <v-btn
                    class="ml-2"
                    small
                    color="primary"
                    @click="reset()"
                    outlined
                    size="small"
                    :disabled="showLoading"
            >
                Reset
            </v-btn>

            <v-btn
                    @click="$emit('saveWorkingHours', workingHours)"
                    small
                    class="ml-2"
                    variant="contained"
                    size="small"
                    color="primary"
                    :disabled="showLoading"
                    :loading="showLoading"
            >
                Save Changes
            </v-btn>
        </div>
    </div>
</template>

<script>
import AppWorkingHoursSlider from "@/components/Shared/AppWorkingHours/AppWorkingHoursSlider";
export default {
    components: {AppWorkingHoursSlider},
    props: {
        value: Array
    },
    data() {
        return {
            workingHours: [
                {start: 16, end: 33, target: 7.5},
                {start: 16, end: 33, target: 7.5},
                {start: 16, end: 33, target: 7.5},
                {start: 16, end: 33, target: 7.5},
                {start: 16, end: 33, target: 7.5},
                {start: 0, end: 0, target: 0},
                {start: 0, end: 0, target: 0},
            ],
            dayTitles: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'],
            labels: (() => {
                const arr = [];
                for(let k = 1; k < 48; ++k) {
                    if (k % 4 === 0)
                        arr.push(`${((k*2) / 4) - (k > 24 ? 12 : 0)}${(k >= 24 ? 'pm' : 'am')}`)
                    else
                        arr.push(null)
                }
                return arr
            })(),
            showLoading: false
        }
    },
    watch: {
        value: {
            immediate: true,
            handler(val) {
                this.reset()
            }
        }
    },
    methods: {

        sliderInput(ref, val) {
            ref.start = val.start
            ref.end = val.end
        },

        reset() {
            if (!this.value || this.value.length !== 7)
                this.workingHours = [
                    {start: 16, end: 33, target: 7.5},
                    {start: 16, end: 33, target: 7.5},
                    {start: 16, end: 33, target: 7.5},
                    {start: 16, end: 33, target: 7.5},
                    {start: 16, end: 33, target: 7.5},
                    {start: 0, end: 0, target: 0},
                    {start: 0, end: 0, target: 0},
                ]
            else
                this.workingHours = JSON.parse(JSON.stringify(this.value))
            this.showLoading = false
        }
    },
    created() {

    },

    computed: {
    },
}
</script>

<style scoped>

</style>